
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.641 8.47a.5.5 0 01.701.094l2.667 3.5a.5.5 0 01-.085.693l-3.11 2.5a.5.5 0 11-.627-.78l2.731-2.194L8.547 9.17a.5.5 0 01.094-.7zm3.248 6.397a.5.5 0 01.5-.5H15.5a.5.5 0 110 1h-3.111a.5.5 0 01-.5-.5z","fill":"#D73F47"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.978 3.922a1.5 1.5 0 00-1.544-.017L4.743 7.817A1.5 1.5 0 004 9.112v7.324a1.5 1.5 0 00.853 1.354l6.695 3.203a1.5 1.5 0 001.322-.014l6.305-3.175a1.5 1.5 0 00.825-1.34V9.083a1.5 1.5 0 00-.714-1.277l-6.308-3.883zm-2.048-.88a2.5 2.5 0 012.572.029l6.308 3.882A2.5 2.5 0 0121 9.083v7.382a2.5 2.5 0 01-1.376 2.232l-6.304 3.175a2.5 2.5 0 01-2.204.023l-6.695-3.203A2.5 2.5 0 013 16.436V9.112a2.5 2.5 0 011.238-2.158l6.692-3.912z","fill":"#D73F47"}})])
          )
        }
      }
    